import React, {Component} from "react";
import FilterButton from "../../../common/filter-button/filter-button.component";

class WhatsHappeningFilter extends Component {
    render(){
        return(
            <div>
                <h1>Whats Happening</h1>
                <FilterButton filterData={this.props.filterData} filtersub={this.props.filtersub}/>
            </div>
        )
    }
}

export default WhatsHappeningFilter;